(() => {
  const instances = new Map();
  const mediaQuery = window.matchMedia('(min-width: 990px)');

  class FajCollectionStickySidebar {
    constructor(section) {
      this.section = section;
      this.fixedAncestors = [];
      this.onViewportChange = this.onViewportChange.bind(this);
    }

    init() {
      this.prepare();

      if (typeof mediaQuery.addEventListener === 'function') {
        mediaQuery.addEventListener('change', this.onViewportChange);
      } else if (typeof mediaQuery.addListener === 'function') {
        mediaQuery.addListener(this.onViewportChange);
      }
    }

    onViewportChange() {
      this.restoreAncestors();
      this.prepare();
    }

    prepare() {
      if (
        this.section.dataset.stickySidebar !== 'true' ||
        !mediaQuery.matches ||
        !this.section.classList.contains('fajmc--desktop-sidebar-visible') ||
        !this.section.querySelector('[data-fajmc-sidebar-sticky]')
      ) {
        return;
      }

      let ancestor = this.section.parentElement;

      while (ancestor && ancestor !== document.body) {
        const styles = window.getComputedStyle(ancestor);
        const overflowValues = [
          styles.overflow,
          styles.overflowX,
          styles.overflowY
        ];

        const clipsSticky = overflowValues.some((value) =>
          ['hidden', 'clip', 'auto', 'scroll'].includes(value)
        );

        const isActualVerticalScroller =
          ancestor.scrollHeight > ancestor.clientHeight + 2 &&
          ['auto', 'scroll'].includes(styles.overflowY);

        if (clipsSticky && !isActualVerticalScroller) {
          ancestor.classList.add('fajmc-sticky-sidebar-overflow-fix');
          this.fixedAncestors.push(ancestor);
        }

        ancestor = ancestor.parentElement;
      }
    }

    restoreAncestors() {
      this.fixedAncestors.forEach((ancestor) => {
        ancestor.classList.remove('fajmc-sticky-sidebar-overflow-fix');
      });

      this.fixedAncestors = [];
    }

    destroy() {
      this.restoreAncestors();

      if (typeof mediaQuery.removeEventListener === 'function') {
        mediaQuery.removeEventListener('change', this.onViewportChange);
      } else if (typeof mediaQuery.removeListener === 'function') {
        mediaQuery.removeListener(this.onViewportChange);
      }
    }
  }

  const initSection = (section) => {
    if (!section || instances.has(section)) return;

    const instance = new FajCollectionStickySidebar(section);
    instances.set(section, instance);
    instance.init();
  };

  const destroySection = (section) => {
    const instance = instances.get(section);
    if (!instance) return;

    instance.destroy();
    instances.delete(section);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-fajmc]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-fajmc]').forEach(destroySection);

    if (event.target.matches?.('[data-fajmc]')) {
      destroySection(event.target);
    }
  });
})();
